<template>
  <p>正在登陆，请稍后</p>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  mounted() {
    this.login();
  },
  name: "login",
  methods: {
    login() {
      console.log("进来登录了！！");
      axios({
        url: "https://www.szce.com/api/login",

        method: "post",
        data: qs.stringify(this.user),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }).then((res) => {
        localStorage.setItem("token", res.data.data.token);
        this.$router.push({ path: "/webindex" });
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/login.vue